import { StoreThunkDispatch } from 'store/state'
import { V1 } from './net'

export function refreshInsights(ppid: string) {
  return (dispatch: StoreThunkDispatch) => dispatch(V1.refreshInsights(ppid))
}
